// extracted by mini-css-extract-plugin
export default {"wrapper":"OccupancyCabinClass-module__wrapper___dESxn"};